export const contact = {
  title: '문의하기',
  subtitle: '질문이나 요청사항이 있으시면 언제든지 문의해주세요',
  
  // Form Labels
  name: '이름',
  namePlaceholder: '이름을 입력하세요',
  
  email: '이메일 주소',
  emailPlaceholder: 'your.email@example.com',
  
  message: '문의 내용',
  messagePlaceholder: '문의 내용을 입력하세요',
  messageLimit: '최대 1000자',
  
  // Submit
  submitButton: '제출',
  submittingButton: '제출 중...',
  
  // Messages
  successMessage: '문의가 접수되었습니다. 곧 연락드리겠습니다.',
  errorMessage: '오류가 발생했습니다. 다시 시도해주세요.',
  fillRequired: '필수 항목을 입력해주세요',
  messageTooLong: '메시지는 1000자 이내로 입력해주세요'
};
